import { POST_LOADER_DELAY } from '@/constants';
import { IVendor } from '@/services/vendor';
import messages from '../messages';

export default function(this: any) {
  this.$store.commit('loader/ADD', {
    title: 'Creating vendor',
    promise: this.create().then(
      (vendor: IVendor) => {
        this.$router.push({
          name: 'vendor',
          params: {
            vendorId: vendor.id,
          },
        });
      })
      .catch((error: any) => {
        console.error(error);

        this.$store.commit('dialog/CREATE', {
          title: 'Error :(',
          content: messages.ERROR_VENDOR_CREATE,
          compact: true,
          delay: POST_LOADER_DELAY,
          buttons: [
            {
              text: 'Close',
              click: (dialog: any) => dialog.close(),
            },
          ],
        });
      }),
    });
}
